import { Appear } from "@features/motion/Appear"
import { Link } from "eddev/routing"
import { ResponsiveImage } from "./ResponsiveImage"
import { FilmItemFragment } from "../../types.graphql"

export const FilmTile = ({ film }: { film: FilmItemFragment }) => {
  return (
    <Appear className="border border-blue p-4 ml-[-1px] w-[calc(100%+1px)] text-blue group hover:bg-blue hover:text-white">
      <Link href={film.uri} className="w-full flex flex-col gap-2">
        <div className="w-full aspect-[347/217] bg-blue-light/50">
          {film.filmData?.featuredImage && (
            <ResponsiveImage {...film.filmData?.featuredImage} className="w-full h-full object-cover" aspect={16 / 9} />
          )}
        </div>
        <p className="type-title-xxs">{film?.title}</p>
        <p className="type-body-xxs opacity-60">
          {[
            film.filmData?.director,
            film.filmData?.country,
            film.filmData?.year,
            film.filmData?.durationMinutes ? `${film.filmData.durationMinutes} mins` : null,
          ]
            .filter(Boolean)
            .join(" · ")}
        </p>
      </Link>
    </Appear>
  )
}
